module.exports = __webpack_public_path__ + "img/2021_indiana_5.b62d57f5.jpg";